module.exports = __webpack_public_path__ + "static/media/logo_anahuac_footer.6dfdcaaa.png";